import { Route, Routes } from 'react-router-dom';
import { ContentWithHeaderRoute } from '../layout/ContentWithHeaderRoute';
import { routes } from '.';
import { useAuth0 } from '@auth0/auth0-react';
import { useStatelessGet } from '../utils/useStatelessGet';
import { FieldValues } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useStatelessPut } from '../utils/useStatelessPut';
import { mapZohoFieldsToForm } from '../utils/fieldMapper';
import { FamilyDetailsForm } from '../host-family/application/familyDetails/FamilyDetailsForm.tsx';
import { CommunityForm } from '../host-family/application/community/CommunityForm.tsx';
import { FamilyPhotosForm } from '../host-family/application/photos/FamilyPhotosForm.tsx';
import { HouseHomeForm } from '../host-family/application/houseHome/HouseAndHomeForm.tsx';
import { FamilyOverviewForm } from '../host-family/application/familyOverview/FamilyOverviewForm.tsx';
import { AgreementForm } from '../host-family/application/agreement/AgreementForm.tsx';
import { PersonalReferences } from '../host-family/application/personalReferences/PersonalReferences.tsx';

export const HostFamilyRoutes = () => {
  const { user } = useAuth0();

  // TODO: change this once MW endpoints are done
  const zohoApplicationId = user?.userData.zohoApplicationId;
  const getHostFamilyApplication = useStatelessGet<FieldValues>(`/api/student-applications/${zohoApplicationId}`);
  const putHostFamilyApplication = useStatelessPut(`/api/student-applications/${zohoApplicationId}`);
  const [applicationData, setApplicationData] = useState<FieldValues | undefined>();

  useEffect(() => {
    if (zohoApplicationId) {
      getHostFamilyApplication().then((res) => setApplicationData(mapZohoFieldsToForm(res, 'hostFamily')));
    }
  }, [getHostFamilyApplication, zohoApplicationId]);

  const subRoutes = routes.hostFamily.subRoutes?.[0].routes;

  return (
    <Routes>
      <Route element={<ContentWithHeaderRoute />}>
        <Route path={subRoutes?.familyOverview.url} element={<FamilyOverviewForm />} />
        <Route
          path={subRoutes?.familyDetails.url}
          element={<FamilyDetailsForm applicationData={applicationData} submitApplication={putHostFamilyApplication} />}
        />
        <Route path={subRoutes?.houseHome.url} element={<HouseHomeForm />} />
        <Route path={subRoutes?.community.url} element={<CommunityForm applicationData={applicationData} submitApplication={putHostFamilyApplication} />} />
        <Route path={subRoutes?.photos.url} element={<FamilyPhotosForm />} />
        <Route path={subRoutes?.agreement.url} element={<AgreementForm />} />
        <Route path={subRoutes?.personalReferences.url} element={<PersonalReferences submitApplication={putHostFamilyApplication} />} />
      </Route>
    </Routes>
  );
};
